import React, { useEffect, useState, useRef } from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { LOGOUT } from 'ConstComponents';
import { Container, Grid, Paper, CircularProgress } from '@material-ui/core';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { PLEASE_PROVIDE_VALID } from 'Components/Helper/Messages';
import HOCLoader from 'Components/Loader/HOCLoader';

import {
    AddOwnBeneficiary as INSERT,
    SelectOwnAccountSummery as SELECT,
    SelectBeneficiary as SELECT_BENE,
} from 'Components/Api/CreditInstitutionSettingAPI';
import {
    PrimaryButton,
    SecondaryButton
} from 'Components/Inputes/CustomButton';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';

const CustomContainer = HOCLoader(Container);

export const AddOwnBeneficiary = () => {
    const classes = commonStyle();
    const [responseMessage, setResponseMessage] = useState('');

    const [beneAccountNo, setBeneAccountNo] = useState('');
    const [branchNo, setBranchNo] = useState('');
    const [mobileNo, setMobileNo] = useState('');
    const [name, setName] = useState('');
    const [branchName, setBranchName] = useState('');

    const [loadingOpen, setLoadingOpen] = useState(false);
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [formObj, setFormObj] = useState({
        AccNo: '',
        TransferLimit: ''
    });

    const reset = () => {
        setFormObj({
            TransferLimit: '',
        });
        setBranchName();
        setName();
        setMobileNo();
        setBeneAccountNo();
    };


    const validationSchema = Yup.object({

        TransferLimit: Yup.number()
            .moreThan(0, PLEASE_PROVIDE_VALID + 'TransferLimit')
            .required(PLEASE_PROVIDE_VALID + 'TransferLimit'),

    });



    const select = async (AccNo) => {
        const inputObj = {
            AccNo: AccNo,
        };
        var reqObj = JSON.stringify(inputObj);

        const { isAuthorized, status, data } = await SELECT(reqObj);

        if (!isAuthorized) LOGOUT();

        if (!status) {
            setResponseMessage(data);
            setIsError(true);
            return;
        }

        var d = JSON.parse(data);
        setBranchName(d.BranchName);
        setBeneAccountNo(d.AccountNo);
        setName(d.Name);
        setMobileNo(d.MobileNo);
        setBranchNo(d.BranchNo);
    };

    const submithandle = async (values, { setSubmitting, resetForm }) => {
        if (loadingOpen) return;
        var jsonReq = {
            Name: name,
            BranchNo: branchNo,
            AccNo: beneAccountNo,
            MobileNo: mobileNo,
            TransferLimit: values.TransferLimit,
        };

        setIsError(false);
        var requestObj = JSON.stringify(jsonReq);
        setLoadingOpen(true);

        var response = await INSERT(requestObj);

        setLoadingOpen(false);

        if (!response.isAuthorized) LOGOUT();
        setSeverity('success');
        setResponseMessage(response.data);
        setIsError(true);
        if (!response.status) {
            setSeverity('error');
            return;
        }
        reset();
    };

    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                enableReinitialize={true}
                initialValues={formObj}
                validationSchema={validationSchema}
                onSubmit={submithandle}
                resetForm={formObj}
                render={({ formProps, values, setFieldValue }) => {
                    return (
                        <Grid
                            item
                            container
                            margin="normal"
                            xs={12}
                            md={12}
                            sm={12}
                            lg={12}
                            spacing={2}
                        >

                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <Form>
                                    <Paper className={classes.PaperStyle}>
                                        <Grid container spacing={3}>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={12}
                                                lg={12}
                                            >
                                                <MaterialNumberField
                                                    label="Account No"
                                                    name="AccNo"
                                                    type="text"
                                                    placeholder="Account No"
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                                <PrimaryButton
                                                    type="reset"
                                                    variant="contained"
                                                    color="primary"
                                                    title="Search"
                                                    className={
                                                        classes.CustomDangerButtonStyle
                                                    }
                                                    onClick={() => select(values.AccNo)}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                <span style={{ fontSize: '16px', fontWeight: '600' }}>
                                                    Account No:  {beneAccountNo}
                                                </span>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={12} lg={12}>

                                                <span style={{ fontSize: '16px', fontWeight: '600' }}>
                                                    Account Holder Name:  {name}

                                                </span>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={12} lg={12}>

                                                <span style={{ fontSize: '16px', fontWeight: '600' }}>
                                                    Branch Name:  {branchName}

                                                </span>
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                <span style={{ fontSize: '16px', fontWeight: '600' }}>
                                                    Mobile:  {mobileNo}
                                                </span>
                                            </Grid>


                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={12}
                                                lg={12}
                                            >
                                                <MaterialTextField
                                                    label="Transfer Limit"
                                                    name="TransferLimit"
                                                    type="text"
                                                    placeholder="Transfer Limit"
                                                />
                                            </Grid>
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={12}
                                            lg={12}
                                            spacing={2}
                                            container
                                            className={classes.footerGrid}
                                        >
                                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                                <SecondaryButton
                                                    type="reset"
                                                    variant="contained"
                                                    color="secondary"
                                                    title="Reset"
                                                    className={
                                                        classes.CustomDangerButtonStyle
                                                    }
                                                    onClick={(e) => reset()}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                                <PrimaryButton
                                                    type="submit"
                                                    title="Submit"
                                                    className={
                                                        classes.CustomPrimaryButtonStyle
                                                    }
                                                    disabled={loadingOpen}
                                                />
                                                {loadingOpen && (
                                                    <CircularProgress
                                                        size={24}
                                                        className={classes.buttonProgress}
                                                    />
                                                )}
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                </Form>
                            </Grid>

                        </Grid>


                    );
                }}
            />
        </CustomContainer>
    );

};